/**
 * Decision Brief — Top-level Surface
 *
 * Third product surface alongside the Elevation Platform (/home) and the
 * Prioritization App (/prioritization). Routes under /brief/*.
 *
 * Public routes (no auth, token-gated):
 *   /brief/submit/:token  — proposal submission form
 *   /brief/view/:token    — read-only shareable artifact
 *
 * Auth-gated routes:
 *   /brief                — Decisions (needs you / waiting on others / decided)
 *   /brief/new            — one-screen creation (a draft exists from the first keystroke)
 *   /brief/:id            — the decision page (one vertical page, one next action)
 *
 * The auth-gated routes are also gated by the `decision_brief` workspace
 * module (the Decision Log — on by default, switchable, owner ruling
 * 2026-10-14). Off →
 * redirect to the Decisions page (/prioritization/decisions). The public token
 * routes above are never gated: links already sent to option owners, or shared
 * as the record, keep working.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { ModuleRouteGuard } from '../../components/guards/ModuleRouteGuard';
import DecisionsListPage from './DecisionsListPage';
import NewDecisionPage from './NewDecisionPage';
import DecisionPage from './DecisionPage';
import BriefSubmit from './BriefSubmit';
import BriefView from './BriefView';

export default function BriefApp() {
  return (
    <Routes>
      {/* Public, token-gated — no auth required */}
      <Route path="submit/:token" element={<BriefSubmit />} />
      <Route path="view/:token" element={<BriefView />} />

      {/* Auth-gated (RequireAuth wraps the /brief/* mount in App.tsx) and
          module-gated (decision_brief). */}
      <Route element={<ModuleRouteGuard moduleKey="decision_brief" redirectTo="/prioritization/decisions" />}>
        <Route index element={<DecisionsListPage />} />
        <Route path="new" element={<NewDecisionPage />} />
        <Route path=":id" element={<DecisionPage />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/brief" replace />} />
      </Route>
    </Routes>
  );
}
